import { mountCookieConsent } from '@el7ven/cookie-kit/js'
import { createAnalyticsManager } from '@el7ven/cookie-kit/analytics'

const initCookies = () => {
    const lang = document.documentElement.lang || 'ro'
    const texts = window.__COOKIE_CONSENT_TEXTS__ || {}
    const cats = texts.categories || {}

    mountCookieConsent({
        lang,
        mode: 'gdpr',
        excludePaths: ['*/privacy-policy', '*/terms-and-conditions', '*/privacy', '*/terms', '*/cookie', '*/politica-de-confidentialitate', '*/termeni-si-conditii'],
        categories: {
            necessary:   { required: true,  enabled: true, disabled: true,  label: cats.necessary?.label,   description: cats.necessary?.description },
            analytics:   { required: false, enabled: false, disabled: false, label: cats.analytics?.label,   description: cats.analytics?.description },
            marketing:   { required: false, enabled: false, disabled: false, label: cats.marketing?.label,   description: cats.marketing?.description },
            preferences: { required: false, enabled: false, disabled: false, label: cats.preferences?.label, description: cats.preferences?.description },
        },
        policies: {
            privacy: texts.privacy_policy_url || '/privacy',
            cookies: texts.privacy_policy_url || '/privacy',
        },
        texts: {
            gdpr: {
                title:   texts.title,
                message: texts.message,
            },
            buttons: {
                acceptAll:       texts.accept_all,
                rejectAll:       texts.reject_all,
                acceptSelection: texts.accept_selection,
                settings:        texts.settings,
            },
            settings: {
                title:   texts.settings_title,
                tabs:    { privacy: texts.privacy_tab },
                privacy: { intro: texts.privacy_intro },
                links:   { moreInfo: texts.more_info, cookieDetails: texts.cookie_details },
            },
        },
    }, 'cookie-consent-root')

    const ids = window.__ANALYTICS_IDS__
    if (ids) {
        const analytics = createAnalyticsManager({
            gtm:               ids.gtm               || undefined,
            ga4:               ids.ga4               || undefined,
            metaPixel:         ids.metaPixel         || undefined,
            yandexMetrica:     ids.yandexMetrica     || undefined,
            googleRemarketing: ids.googleRemarketing || undefined,
        })
        analytics.init()
        analytics.connectToCookieConsent()
    }
}

export default initCookies
